import { Injectable } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AppHttpService } from '../app-http.service';

@Injectable()
export class Validator {
  constructor(private httpService: AppHttpService) {}

  validateZip(): ValidatorFn {
    return (input: AbstractControl): { [key: string]: any } => {
      const zip = input.value;

      this.httpService.validate('zip', zip);

      const no = '';
      return no ? { forbiddenName: { name } } : null;
    };
  }
}
